import Vue from 'vue'
import AppLimitsAPI from '@/api/campaigns/app_limits'

const limitsModel = {
  max_active_campaigns: 0,
  max_monthly_influencers: 0,
}

const usageModel = {
  // monthly influencers accepted or pending or draft
  monthly_influencers: 0,
  monthly_influencers_list: [],
  all_influencers: 0,
  all_influencers_list: [],
  // monthly campaigns active or scheduled
  campaigns: 0,
}

export const state = {
  appLimits: { ...limitsModel },
  appUsage: { ...usageModel },

  limitsLoaded: false,
  isUsageLoading: false,

  tags: {
    modal: {
      customTags: false,
    },
    selectedTemplate: null,
  },

  contentApproval: {
    bulkSelectedContentsById: [],
  },

  creatorsReview: {
    bulkSelection: [],
  },

  bulkMessage: {
    isModalOpen: false,
  },
  creatorsAdded: 0,
}

export const getters = {
  creatorsAdded: (state) => state.creatorsAdded,
  percentLimit: (state) => parseInt((state.appUsage.monthly_influencers / state.appLimits.max_monthly_influencers) * 100),
  monthlyInfluencers: (state) => state.appUsage.monthly_influencers,
}

export const actions = {
  async loadClientAppLimits({ commit, state }, params) {
    state.limitsLoaded = false
    state.isUsageLoading = true

    try {
      const { data } = await AppLimitsAPI.getClientLimits(params.campaign_id)

      if (data.quota !== false && data.usage !== false) {
        commit('setAppLimits', data.quota)
        commit('setAppUsage', data.usage)
      } else {
        state.limitsLoaded = true
        state.isUsageLoading = false
      }
    } catch (e) {
      console.warn(e.message)
    }
  },

  async loadAppLimits({ commit, state }) {
    state.limitsLoaded = false
    state.isUsageLoading = true

    try {
      const { data } = await AppLimitsAPI.getLimits()

      commit('setAppLimits', data.quota)
      commit('setAppUsage', data.usage)
    } catch (e) {
      console.warn(e.message)
    }
  },
  // this.$store.dispatch('creativeStudio/loadAppUsage')
  async loadAppUsage({ commit, state }, campaignId) {
    state.isUsageLoading = true

    try {
      const { data } = await AppLimitsAPI.getUsage(campaignId)

      commit('setAppUsage', data)
    } catch (e) {
      console.warn(e.message)
    }
  },

  overrideAppLimits({ commit }, data) {
    try {
      commit('setAppLimits', data.quota)
      commit('setAppUsage', data.usage)
    } catch (e) {
      console.warn(e.message)
    }
  },
}

export const mutations = {
  SET_CREATORS_ADDED(state, payload) {
    state.creatorsAdded = payload
  },
  RESET(state) {
    state.appLimits = { ...limitsModel }
    state.appUsage = { ...usageModel }

    state.limitsLoaded = false
    state.isUsageLoading = false
  },

  setAppLimits(state, payload) {
    // console.log('setAppLimits', payload)
    state.appLimits.max_active_campaigns = payload.max_active_campaigns || 0
    state.appLimits.max_monthly_influencers = payload.max_monthly_influencers || 0

    state.limitsLoaded = true
  },

  setAppUsage(state, payload) {
    // console.log('setAppUsage', payload)
    state.appUsage.monthly_influencers = payload.monthly_influencers || 0
    state.appUsage.monthly_influencers_list = payload.monthly_influencers_list || []
    state.appUsage.all_influencers = payload.all_influencers || 0
    state.appUsage.all_influencers_list = payload.all_influencers_list || []
    state.appUsage.campaigns = payload.campaigns || 0

    state.isUsageLoading = false
  },

  toggleBulkSelectContent(state, payload) {
    const isInList = state.contentApproval.bulkSelectedContentsById.includes(payload.id)

    // add
    if (!isInList && payload.value === true) state.contentApproval.bulkSelectedContentsById.push(payload.id)

    // remove
    if (isInList && payload.value === false) {
      const index = state.contentApproval.bulkSelectedContentsById.indexOf(payload.id)
      Vue.delete(state.contentApproval.bulkSelectedContentsById, index)
    }
  },

  toggleBulkSelectCreatorReviews(state, payload) {
    const isInList = state.creatorsReview.bulkSelection.includes(payload.id)

    // add
    if (!isInList && payload.value === true) state.creatorsReview.bulkSelection.push(payload.id)

    // remove
    if (isInList && payload.value === false) {
      const index = state.creatorsReview.bulkSelection.indexOf(payload.id)
      Vue.delete(state.creatorsReview.bulkSelection, index)
    }

    if (state.creatorsReview.bulkSelection.length === 0) state.creatorsReview.bulkTagActionsDisabled = false
    if (state.creatorsReview.bulkSelection.length === 0) state.creatorsReview.bulkStatusActionsDisabled = false
  },
}
